module.exports = __webpack_public_path__ + "static/TiemposHeadline-LightItalic-7d8dbb7cfc8006a4676aa7463cd4eafc.woff";